import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'content'
})`
  @media only screen and (max-height: 768px) {
    padding-bottom: 24px;
  }
`;

export const TabHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 24px;

  h1 {
    flex: 1;
  }

  p {
    flex: 1;
    color: rgba(22,20,20,.2);
  }
`;

export const CartItemContainer = styled.div`
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`;

export const CartItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
`;

export const CartItemsList = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f4f4f4;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const CartItemDetails = styled.div`
  margin-top: 15px;
`;

export const CartDetailsSection = styled.div`
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;
`;

export const CartEventTimeline = styled.div`
  margin-top: 20px;
`;

export const CartEvent = styled.div`
  padding: 10px;
  border-left: 3px solid #CB3D42;
  margin-bottom: 8px;
  background-color: #f9f9f9;
`;

export const CartEventTime = styled.span`
  font-size: 12px;
  color: #666;
  margin-right: 10px;
`;

export const CartEventType = styled.span`
  font-weight: bold;
`;

export const CartEventDetail = styled.div`
  margin-top: 5px;
  font-size: 14px;
  color: #444;
`;

export const SearchBar = styled.div`
  display: flex;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    
    > div {
      margin-bottom: 10px;
    }
  }
`;

export const NoResultsMessage = styled.div`
  text-align: center;
  padding: 20px;
  color: #666;
`;

export const PromotionTag = styled.div`
  display: inline-block;
  background-color: #CB3D42;
  color: white;
  padding: 3px 8px;
  border-radius: 3px;
  font-size: 12px;
  margin-right: 5px;
  margin-bottom: 5px;
`;

export const CartSummary = styled.div`
  margin-top: 15px;
  border-top: 1px dashed #ccc;
  padding-top: 15px;
  
  div {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  
  .total {
    font-weight: bold;
    font-size: 1.1em;
    margin-top: 10px;
    border-top: 1px solid #eee;
    padding-top: 10px;
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
  
  @media (max-width: 576px) {
    flex-direction: column;
    
    button {
      margin-right: 0 !important;
      margin-bottom: 10px;
    }
  }
`;